export default __webpack_public_path__ + "static/media/yellowTheme-boy.9ddb06c0.svg";